import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
import heroBgDesktop from '../../assets/HERO Mixto.png';
import heroBgMobile from '../../assets/Hero Mixto Mobile.png';

const Hero = ({ onStart, onStartAtajar }) => (
  <section className="hero-section" style={{ '--bg-desktop': `url(${heroBgDesktop})`, '--bg-mobile': `url(${heroBgMobile})` }}>
    <div className="hero-overlay" />
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
      className="container hero-content"
      style={{ textAlign: 'center' }}
    >
      {/* Ticker de Lanzamiento */}
      <motion.div
        initial={{ y: -20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.6 }}
        style={{
          background: 'linear-gradient(90deg, rgba(212, 255, 0, 0.1) 0%, rgba(212, 255, 0, 0.15) 50%, rgba(212, 255, 0, 0.1) 100%)',
          border: '1px solid rgba(212, 255, 0, 0.3)',
          borderRadius: '8px',
          padding: '0.6rem 1rem',
          marginBottom: '2rem',
          display: 'inline-block',
          backdropFilter: 'blur(10px)'
        }}
      >
        <p style={{ margin: 0, color: 'var(--primary)', fontSize: '0.85rem', fontWeight: 800, letterSpacing: '0.05em' }}>
          ⚠️ ¿Se te bajó uno a último momento? Encontrá su reemplazo hoy en Citados.
        </p>
      </motion.div>

      <div style={{ maxWidth: '900px', margin: '0 auto', textAlign: 'center' }}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.8 }}
        >
          <span className="glass" style={{
            display: 'inline-block',
            padding: '0.6rem 1.4rem',
            borderRadius: '99rem',
            fontSize: '0.85rem',
            color: 'var(--primary)',
            fontWeight: 700,
            letterSpacing: '0.1em',
            textTransform: 'uppercase',
            border: '1px solid rgba(var(--primary-rgb), 0.2)',
            backdropFilter: 'blur(20px)',
            boxShadow: '0 10px 30px rgba(0,0,0,0.3)',
            lineHeight: 1.4
          }}>
            ⚡ FASE BETA ABIERTA: SUMATE HOY
          </span>
        </motion.div>

        <h1 style={{
          fontSize: 'clamp(3rem, 12vw, 6.5rem)',
          marginTop: '2.5rem',
          marginBottom: '1.5rem',
          lineHeight: 0.9,
          letterSpacing: '-0.04em',
          textShadow: '0 10px 40px rgba(0,0,0,0.6)'
        }}>
          La pelota<br />
          <span className="primary-gradient" style={{ WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', display: 'inline-block', filter: 'drop-shadow(0 0 20px rgba(var(--primary-rgb), 0.3))' }}>NO se mancha.</span>
        </h1>

        <p style={{
          color: 'rgba(255,255,255,0.8)',
          fontSize: 'clamp(1.1rem, 3vw, 1.4rem)',
          maxWidth: '700px',
          margin: '0 auto 3.5rem',
          lineHeight: 1.5,
          fontWeight: 400,
          textShadow: '0 2px 10px rgba(0,0,0,0.5)'
        }}>
          No dejes que la falta de jugadores arruine tu semana. Citados conecta al instante a organizadores con jugadores de tu nivel en tu zona. El partido se juega, los puntos se ganan y tu EXP sube.
        </p>

        <motion.div
          style={{ display: 'flex', flexDirection: 'column', gap: '1.2rem', justifyContent: 'center', maxWidth: '400px', margin: '0 auto' }}
          className="mobile-actions"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 0.8 }}
        >
          <motion.button
            className="btn-primary"
            onClick={onStart}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            style={{
              padding: 'clamp(1rem, 4vw, 1.4rem) clamp(1.5rem, 5vw, 3rem)',
              fontSize: 'clamp(1.1rem, 4vw, 1.2rem)',
              width: '100%',
              boxShadow: '0 20px 50px rgba(var(--primary-rgb), 0.25)',
              border: '1px solid rgba(255,255,255,0.2)'
            }}
          >
            Buscar Jugador de Emergencia <ChevronRight size={22} />
          </motion.button>

          {/* Fundador CTA */}
          <div style={{
            background: 'rgba(255,255,255,0.03)',
            border: '1px solid rgba(255,255,255,0.1)',
            borderRadius: '12px',
            padding: '0.8rem 1rem',
            marginTop: '0.5rem',
            backdropFilter: 'blur(10px)'
          }}>
            <p style={{ margin: 0, fontSize: '0.8rem', color: 'rgba(255,255,255,0.7)', lineHeight: 1.4 }}>
              🎮 <strong>¡Sumate hoy gratis!</strong> Armá tu Carta FUT con estadísticas reales y ganá EXP salvando los partidos de tu zona.
            </p>
          </div>
        </motion.div>
      </div>

      <style>{`
        .hero-section {
          background-image: var(--bg-desktop) !important;
          background-position: center;
        }
        @media (max-width: 768px) {
          .hero-section {
            background-image: var(--bg-mobile) !important;
            background-position: center top !important;
          }
          .mobile-actions {
            flex-direction: column !important;
          }
        }
        @media (min-width: 768px) {
          .mobile-actions {
            flex-direction: row !important;
            max-width: none !important;
          }
          .mobile-actions button {
            width: auto !important;
          }
        }
      `}</style>

      <div style={{ marginTop: '5rem', display: 'flex', flexWrap: 'wrap', gap: '3rem', justifyContent: 'center', textAlign: 'center' }}>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1, duration: 1 }}
          style={{ minWidth: '150px' }}
        >
          <h3 style={{ fontSize: 'clamp(1.8rem, 5vw, 2.8rem)', color: 'var(--primary)', marginBottom: '0.2rem' }}>Lanzamiento</h3>
          <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.9rem', fontWeight: 600, letterSpacing: '0.1em' }}>FASE BETA ABIERTA</p>
        </motion.div>
        {/* 
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.2, duration: 1 }}
          style={{ textAlign: 'center', minWidth: '150px' }}
        >
          <h3 style={{ fontSize: 'clamp(1.8rem, 5vw, 2.8rem)', color: '#fff', marginBottom: '0.2rem' }}>+300</h3>
          <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.9rem', fontWeight: 600, letterSpacing: '0.1em' }}>JUGADORES Y EQUIPOS</p>
        </motion.div>
        */}
      </div>
    </motion.div>
  </section>
);

export default Hero;
